<!-- Componente de Loading Global -->
<app-loading></app-loading>

<!-- Toast de Tarefas em Background -->
<app-background-task-toast></app-background-task-toast>

<!-- Conteúdo Principal -->
<router-outlet></router-outlet>
